import { fetchConfig, getSectionsToRender, Animations } from '@lib/section-utils';
export const ON_CHANGE_DEBOUNCE_TIMER = 300;
export const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

let subscribers = {};

export function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => cb !== callback);
  };
}

export function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName].map((callback) => callback(data));
    return Promise.all(promises);
  } else {
    return Promise.resolve();
  }
}

// export function pauseAllMedia() {
//   document.querySelectorAll('.js-youtube').forEach((video) => {
//     video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
//   });
//   document.querySelectorAll('.js-vimeo').forEach((video) => {
//     video.contentWindow.postMessage('{"method":"pause"}', '*');
//   });
//   document.querySelectorAll('video').forEach((video) => video.pause());
//   document.querySelectorAll('product-model').forEach((model) => {
//     if(model){
//       if (model.modelViewerUI) model.modelViewerUI.pause();
//     }
//   });
// }
export function pauseAllMedia(except = null) {
  // Pause all video-media elements except the one provided
  document.querySelectorAll('video-media').forEach(video => {
    if (video !== except) video.pauseAll?.();
  });
  // Pause all product-model elements except the one provided
  document.querySelectorAll('product-model').forEach(model => {
    if (model !== except && model.modelViewerUI) model.modelViewerUI.pause();
  });
}

export function shippingconversion() {
  const cartElement = document.querySelector('[data-cart-shippingbar]');
  const progressBar = document.querySelector('[data-cart-progress]');

  if (cartElement) {
    const cartTotal = Number(cartElement.getAttribute('data-cart-total'));
    const shippingRate = Number(cartElement.getAttribute('data-cart-rate'));
    const shippingThreshold = Number(cartElement.getAttribute('data-cart-shipping'));

    const shippingTextTemplate = cartElement.getAttribute('data-shipping-text');
    const congratulationsText = cartElement.getAttribute('data-congratulations-text');

    // ⚠️ Only apply conversion if values are in base currency
    const conversionRate = Shopify.currency?.rate || 1;

    const shippingRateInCurrentCurrency = shippingRate * conversionRate;
    const cartTotalInCurrentCurrency = cartTotal * conversionRate;
    const remainingAmount = Math.max(0, shippingRate - cartTotal);

    const progress = Math.min((cartTotalInCurrentCurrency / shippingRateInCurrentCurrency) * 100, 100).toFixed(2);

    setTimeout(() => {
      if (progressBar) {
        progressBar.style.setProperty('--eligibility-progress', `${progress}%`);
      }

      const amount = Number(remainingAmount);


      if (amount > 0) {
        const formattedAmount = formatMoney(remainingAmount, Shopify.currency.money_format);
        cartElement.innerText = shippingTextTemplate.replace('[amount]', formattedAmount);
      } else {
        cartElement.innerText = congratulationsText;

      }
    }, 1000);


  }
}

export function renderShipping() {
  const cartElement = document.querySelector('[data-cart-shippingbar]');
  const progressBar = document.querySelector('[data-cart-progress]');
  const customElements = document.querySelector('cart-drawer') || document.querySelector('cart-items');

  const amount = customElements?.querySelector('[data-total-amount]');

  if (amount && cartElement) {
    const total_amount = amount.getAttribute('data-total-amount');
    cartElement.setAttribute('data-cart-total', total_amount);
  }
}

export function renderGiftWrapp() {
  const giftWrapping = document.querySelector('gift-wrapping');
  const customElements = document.querySelector('cart-drawer') || document.querySelector('cart-items');
  const cart = customElements?.querySelector('[data-items-cart]');

  if (cart && giftWrapping) {
    const item_size = cart.getAttribute('data-total-items');
    giftWrapping.setAttribute('cart-items-size', item_size);
    const items_cart = cart.getAttribute('data-items-cart');
    giftWrapping.setAttribute('items-in-cart', items_cart);
  }
}

export function formatMoney(cents, format = "{{ amount }}") {
  if (isNaN(cents) || cents === null) return "0";

  const moneyRegex = /\{\{\s*(\w+)\s*\}\}/;
  const placeholder = format.match(moneyRegex)?.[1];

  function formatWithDelimiters(amount, precision = 2, thousands = ",", decimal = ".") {
    const parts = (amount / 100).toFixed(precision).split(".");
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return precision > 0 ? `${integerPart}${decimal}${parts[1]}` : integerPart;
  }

  let formatted = "";
  switch (placeholder) {
    case "amount":
      formatted = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      formatted = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      formatted = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      formatted = formatWithDelimiters(cents, 0, ".", ",");
      break;
    default:
      formatted = (cents / 100).toFixed(2); // fallback
  }

  return format.replace(moneyRegex, formatted);
}

export function openDrawer(drawerName, triggeredBy = null) {
  if(document.body.classList.contains('hamburger-open')){
    document.body.classList.remove('hamburger-open');
  }
  const drawer = document.querySelector(`[data-drawer="${drawerName}"]`);
  if (!drawer) return;

  const all_drawers = document.querySelectorAll('.offcanvas');
  all_drawers.forEach((drawer) => {
    drawer.classList.remove("offcanvas-open");
  });
  drawer.classList.add('offcanvas-open');
  Animations.initAll();
}

export function closeDrawer(drawerName) {
  const drawer = document.querySelector(`[data-drawer="${drawerName}"]`);
  if (!drawer) return;

  drawer.classList.remove('offcanvas-open');

}

const setScrollbarWidth = () => {
  const scrollbarWidth = window.innerWidth - document.body.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
};

setScrollbarWidth();

window.addEventListener('resize', setScrollbarWidth);

const resizeObserver = new ResizeObserver(() => {
  setScrollbarWidth();
});

resizeObserver.observe(document.body);


let __iosScrollLockY = 0;
let __iosScrollLocked = false;
function __isIOS() {
  const platform = navigator.platform || '';
  const ua = navigator.userAgent || '';
  const isIOSDevice = /iP(hone|ad|od)/.test(platform);
  const isTouchMac = ua.includes('Mac') && 'ontouchend' in document;
  return isIOSDevice || isTouchMac;
}

export function overflowAdd() {
  if (__isIOS()) {
    __iosScrollLockY = window.scrollY || window.pageYOffset || 0;
    __iosScrollLocked = true;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${__iosScrollLockY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('overflow-hidden');
  } else {
    document.body.classList.add('overflow-hidden');
  }
}

export function overflowRemove() {
  if (__isIOS()) {
    const wasLocked = __iosScrollLocked || document.body.style.position === 'fixed';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.documentElement.classList.remove('overflow-hidden');
    if (wasLocked) {
      window.scrollTo(0, __iosScrollLockY || 0);
    }
    __iosScrollLocked = false;
  } else {
    document.body.classList.remove('overflow-hidden');
  }

  const el = document.querySelector('[data-localization-details]');
  if (el && el.classList.contains('open')) {
    el.classList.remove('open');
  }
}

function getFocusableElements(container) {
  const focusableSelectors = [
    "a[href]",
    "button:not([disabled])",
    "textarea:not([disabled])",
    "input:not([type=hidden])",
    "select:not([disabled])",
    "summary",
    "[tabindex]:not([tabindex='-1'])"
  ];

  const isVisible = (el) => {
    if (!el) return false;

    let node = el;
    while (node && node !== document.body) {
      const style = window.getComputedStyle(node);
      if (
        style.display === "none" ||
        style.visibility === "hidden" ||
        style.opacity === "0" ||
        node.hidden
      ) {
        return false;
      }
      node = node.parentElement;
    }
    return true;
  };

  return Array.from(container.querySelectorAll(focusableSelectors.join(","))).filter(isVisible);
}

const trapFocusHandlers = {};

export function trapFocus(container, elementToFocus) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {

    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) {
    elementToFocus.focus();
    // if (
    //   elementToFocus.tagName === 'INPUT' &&
    //   ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    //   elementToFocus.value
    // ) {
    //   elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    // }
  } else {
    if (!container.hasAttribute("tabindex")) {
      container.setAttribute("tabindex", "-1");
    }

    container.focus();
  }
}
